<div class="xwai-v2-container">
<div class="chat-container">
<div #scrollContainer class="messages-container" (scroll)="onMessagesScroll()">
  @for (msg of messages(); track $index) {
  <div #messageEl [class]="'chat-message chat-message-' + msg.role">
    <!-- this only adds the icon -->
    @if (msg.role === "xwai") {
    <img src="/assets/icons/xwai-icon-cropped.png" alt="XWAI" class="bot-icon" />
    }

    <!-- this adds the message -->
    @if (msg.role === "user") {
    <p class="message-content">{{ msg.content }}</p>
    } @else if(msg.role === "xwai") {
    <div>
      <ng-container *ngTemplateOutlet="messageDetail; context: { $implicit: msg.content }"></ng-container>
    </div>
    } @else{
    <div>
      Who doth sent thine message. thy recognizable not.
      <pre>
              {{msg | json}}
            </pre>
    </div>
    }
  </div>
  }

  <!-- Live, in-flight streaming turn: per-agent activity feed + streamed answer. -->
  @if (sending()) {
  <div #messageEl class="chat-message chat-message-xwai">
    <img src="/assets/icons/xwai-icon-cropped.png" alt="XWAI" class="bot-icon" />
    <div class="stream-live">
      <ng-container *ngTemplateOutlet="agentTrace; context: { $implicit: streamAgents(), orchSteps: streamSteps() }">
      </ng-container>

      <!-- Final answer, streamed token-by-token -->
      @if (streamAnswer()) {
      <div class="message-content" [innerHTML]="streamAnswer() | markdown"></div>
      } @else if (!streamAgents().length && !streamSteps().length) {
      <span class="thinking">{{ thinkingWord() }}…</span>
      }
    </div>
  </div>
  }
</div>
</div>
</div>

<ng-template #messageDetail let-content>
  <div>
    <div class="message-content" [innerHTML]="content.answer | markdown"></div>
    @for (detail of detailsOf(content); track $index) {
    <ng-container *ngTemplateOutlet="detailBlock; context: { $implicit: detail }"></ng-container>
    }

    <!-- Structured, renderable payloads (dashboard deep-links, etc.). -->
    @if (content.artifacts?.length) {
    <app-xwai-artifacts [artifacts]="content.artifacts"></app-xwai-artifacts>
    }

    <!-- Preserved process: the agent activity feed, collapsed by default. -->
    @if (content.activity?.length || content.steps?.length) {
    <details class="agent-trace">
      <summary>
        <span nz-icon nzType="right" nzTheme="outline" class="agent-trace-caret"></span>
        Show steps
        @if (content.activity?.length) { <em>({{ content.activity.length }} agent{{ content.activity.length === 1 ? "" :
          "s" }})</em> }
      </summary>
      <div class="agent-trace-body">
        <ng-container
          *ngTemplateOutlet="agentTrace; context: { $implicit: content.activity || [], orchSteps: content.steps || [] }">
        </ng-container>
      </div>
    </details>
    }

    @if (content?.usage; as usage){
    <div class="usage-metrics">
      <span class="usage-pill"><b>Input</b> {{usage.input_tokens.toLocaleString()}}</span>
      <span class="usage-pill"><b>Output</b> {{usage.output_tokens.toLocaleString()}}</span>
      @if (usage.pricing; as pricing) {
      <span class="usage-pill usage-pill-cost"><b>Cost</b> {{(usage.output_tokens * pricing.output +
        usage.input_tokens * pricing.input).toLocaleString()}}
        <em>({{ (usage.output_tokens * pricing.output).toLocaleString()}} | {{(usage.input_tokens *
          pricing.input).toLocaleString()}})</em></span>
      }
    </div>
    }
  </div>
</ng-template>

<!-- The sub-agent activity feed: shared by the live stream and the collapsed trace. -->
<ng-template #agentTrace let-agents let-orchSteps="orchSteps">
  @for (a of agents; track $index) {
  <div class="agent-block" [class.agent-done]="a.done">
    <div class="agent-head">
      <span class="agent-badge">{{ a.done ? "✓" : "▶" }} {{ a.agent }}</span>
      @if (a.task) { <span class="agent-task">{{ a.task }}</span> }
    </div>
    @if (a.thinking) {
    <div class="agent-think">{{ a.thinking }}</div>
    }
    @for (s of a.steps; track $index) {
    <ng-container *ngTemplateOutlet="toolCall; context: { $implicit: s }"></ng-container>
    }
  </div>
  }

  <!-- Orchestrator-level tool calls (no nested result; just the call). -->
  @for (s of orchSteps; track $index) {
  <ng-container *ngTemplateOutlet="toolCall; context: { $implicit: s, orch: true }"></ng-container>
  }
</ng-template>

<!--
  One tool-call bubble: `label` + `input`, with the matching `agent_tool_result`
  `output` nested underneath in a collapsible, scrollable monospace block.
-->
<ng-template #toolCall let-s let-orch="orch">
  <div class="agent-step" [class.orch-step]="orch">
    <div class="agent-step-call">
      <span class="agent-step-label">⚙ {{ s.label }}</span>
      @if (s.input) { <span class="agent-step-input">{{ s.input | json }}</span> }
    </div>
    @if (s.output) {
    <details class="tool-output">
      <summary>
        <span nz-icon nzType="right" nzTheme="outline" class="tool-output-caret"></span>
        Output
      </summary>
      <pre class="tool-output-body">{{ s.output }}</pre>
    </details>
    }
  </div>
</ng-template>

<!-- Renders one sub-agent's structured output (from `agent_complete.data`). -->
<ng-template #detailBlock let-detail>
  @if(detail['agent'] == "Lineage specialist"){
  @for(tree of detail['data']; track $index){
  @for (property of tree | keyvalue; track $index) {
  <div class="lineage-block">
    <div class="lineage-title">
      Lineage of <strong>{{ $any(property.value)?.job?.name }}</strong>
    </div>
    <!-- type casting with any to allow nested information -->
    @if ($any(property.value)?.tree; as treeStr) {
    <div class="lineage-tree">
      @for (node of treeStr | lineageTree; track $index) {
      <div class="lineage-row" [class.is-target]="node.isTarget" [style.margin-left.px]="node.depth * 18">
        @if (node.depth > 0) {
        <span class="lineage-branch">└─</span>
        }
        <span class="lineage-name">{{ node.name }}</span>
        @if (node.isTarget) { <span class="lineage-target-dot" title="Requested job">★</span> }
        @if (node.cp !== null) { <span class="lineage-cp">cp {{ node.cp }}</span> }
      </div>
      }
    </div>
    }
  </div>
  }
  }
  }
  @else if(detail['agent'] == "Parameters specialist"){
  @for(table of detail['data']; track $index){
  <app-xwai-table [table]="table"></app-xwai-table>
  }
  }
  @else if(detail['agent'] == "Visualization specialist"){
  @for(viz of detail['data']; track $index){
  <app-xwai-viz [viz]="viz"></app-xwai-viz>
  }
  }
  @else if(detail['agent'] == "Trace-fit specialist"){
  @for(data of detail['data']; track $index){
  <app-xwai-trace-fit [data]="data"></app-xwai-trace-fit>
  }
  }
  @else if(detail['agent'] == "Knowledge specialist"){
  <app-xwai-knowledge [data]="detail['data']"></app-xwai-knowledge>
  } @else {
  <pre style="padding: 0; margin: 10px 0; border: none; font-size: 12px;">{{ detail | json }}</pre>
  }
</ng-template>



